import {ReactComponent as DashboardIcon} from "./dashboard.svg";
import {ReactComponent as UserIcon} from "./user.svg";
import {ReactComponent as TermsIcon} from "./terms.svg";
import {ReactComponent as InvoiceIcon} from "./invoice.svg";
import {ReactComponent as FundIcon} from "./fund.svg";


export default {DashboardIcon, UserIcon, TermsIcon, InvoiceIcon, FundIcon};
